import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import RichText from '../shared/JssOverridesRichText';
import {
    BrownFullWidthTextComponent,
    ContentNoMarginComponent,
    OverTheTopIframeWrapper,
    OverTheTopWrapper, 
    ContentTextComponent,
} from './Text.styles';
import SocialMediaComponent from './SubTemplates/SocialMediaComponent.jsx';
import NewsletterFormComponent from './SubTemplates/NewsletterFormComponent.jsx';
import CenteredVideoComponent from './SubTemplates/CenteredVideoComponent.jsx';
import CenteredVideo from './SubTemplates/CenteredVideo.jsx';
import VideoRightComponent from './SubTemplates/VideoRightComponent.jsx';
import VideoTimelineComponent from './SubTemplates/VideoTimelineComponent.jsx';
import BeanGameComponent from './SubTemplates/BeanGameComponent.jsx';
import UpdBeanGameComponent from './SubTemplates/UpdBeanGameComponent.jsx';
import SampleRequestForm from './SubTemplates/SampleRequestForm.jsx';
import OverTheTopSurvey from './SubTemplates/OverTheTopSurvey.jsx';
import AlchemerSurvey from './SubTemplates/AlchemerSurvey.jsx';
import AlchemerSurveyOnPage from './SubTemplates/AlchemerSurveyOnPage.jsx';
import VendorForm from '../VendorForm/VendorForm.jsx';
import { withSitecoreContext, isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import Button from '../shared/Button/Button.jsx';

const Text = ({ title = '',fields = {},sitecoreContext, params = {} }) => {
    const { content = {}, heading = {}, button = {}, tip = {} } = fields;
    const {
        backgroundColor = 'tan',
        alignment = 'left',
        richTextClass = '',
        ytvideo = '',
        centeredVideoModule = '',
        videoPoster = '',
        socialmedia = '',
        centeredVideo = '',
        signupform = '',
        posterText = '',
        buttonText = '',
        buttonUrl = '',
        buttonColor = 'red',
        contestVideoPopup = '',
        vid = '',
        videoTimeline = '',
        beanGame = '',
        id = '',
        bottomLink1 = '',
        bottomLink2 = '',
        textUnderVideo = '',
        timeLineVideo1 = '',
        timeLineVideo2 = '',
        timeLineVideo3 = '',
        timeLineVideo4 = '',
        timeLineVideo5 = '',
        timeLineVideo6 = '',
        disclosure = '',
        backgroundImage = '',
        modalHeading = '',
        modalCopy = '',
        modalLink = '',
        modalButton = '',
        includeModal = '',
        iframetitle = '',
        vimeo = '',
        surveyPage = '',
        hideBeanBurst = '',
        noMargin = '',
        vendorForm = '',
        overTheTop = '',
        overTheTopEmbed = '',
        samplerequest = '',
        sampleRequestFormOutput = '',
        classValue = '',
        submitButtonText = 'Submit',
        alchemer = '',
        alchemerembed = '',
        alchemerembedurl = '',
        alchemeriframeurl = '',
        alchemeriframeheight = '',
        alchemerheading = '',
        ottSurveyIframeUrl = '',
        alchemerembedinpage = '',
        protip = '',
        headingcolor = '',
        textColor = '',
    } = params;

    const { site } = sitecoreContext;
    const richTextClassname = richTextClass ? `content-container ${richTextClass}` : 'content-container';
    const experienceEditor = isEditorActive();
    const vidPoster = videoPoster ? videoPoster : '';

    const [isModalVisible, setIsModalVisible] = useState(false);
    const componentRef = useRef(null);
    const handleButtonClick = () => {
        setIsModalVisible(true);
    };

    const iframeRef = useRef(null);


if (overTheTop === 'true') {
    return (
        <OverTheTopWrapper>
            <OverTheTopIframeWrapper ref={componentRef} id="over-the-top-survey">
                <iframe
                    src={ottSurveyIframeUrl}
                    frameBorder="0"
                    allowFullScreen
                    width="1000"
                    height="1300"
                    style={{ overflow: 'hidden' }}
                ></iframe>
            </OverTheTopIframeWrapper>
        </OverTheTopWrapper>
    );
}

if (overTheTop === 'minesweeper') {
  const jebbitIframeRef = useRef(null);

  React.useEffect(() => {
    function embedJebbit(selector) {
      function toggleEvent(type, fn) {
        const method = type === "attach" ? window.addEventListener : window.removeEventListener;
        method("DOMContentLoaded", check, false);
        method("load", check, false);
        method("scroll", check, false);
        method("resize", check, false);
      }
      const iframe = document.querySelector(selector);
      function check() {
        if (!iframe) return;
        const rect = iframe.getBoundingClientRect();
        const halfHeight = iframe.clientHeight / 2;
        const halfWidth = iframe.clientWidth / 2;
        if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) - halfHeight &&
          rect.left <= (window.innerWidth || document.documentElement.clientWidth) - halfWidth
        ) {
          iframe.contentWindow.postMessage("startJebbitCampaign", "*");
        }
      }
      window.addEventListener(
        "message",
        function handler(e) {
          if (e && e.origin === "https://tiffany.jebbit.com") {
            if (e.data === "jebbitSessionCreated") {
              toggleEvent("remove", check);
            } else if (e.data === "jebbitCampaignLoaded") {
              check();
            } else if (
              e.data &&
              e.data.action === "redirect" &&
              e.data.options &&
              e.data.options.link
            ) {
              window.location.href = e.data.options.link;
            }
          }
        },
        false
      );
      toggleEvent("attach", check);
    }
    embedJebbit(".jebbit-iframe");
  }, []);

  return (
    <iframe
      ref={jebbitIframeRef}
      className="jebbit-iframe"
      src={ottSurveyIframeUrl}
      frameBorder="0"
      allowFullScreen
      style={{ width: "100%", minHeight: "1000px" }}
      title="Jebbit Minesweeper"
    />
  );
}

  if (alchemer === 'true') {
    return (
      <OverTheTopWrapper>
        <RichText
          className={richTextClassname}
          field={content}
          tag="div"
          editable={true.toString()}
        />
        <OverTheTopIframeWrapper ref={componentRef} id="survey">
          <iframe
            ref={iframeRef}
            id={id}
            src={alchemeriframeurl}
            frameBorder="0"
            width="1000"
            height={alchemeriframeheight}
            style={{ overflow: 'hidden' }}
          ></iframe>
        </OverTheTopIframeWrapper>
      </OverTheTopWrapper>
    );
  }

  if (overTheTopEmbed === 'true') {
    return (
      <OverTheTopSurvey
        id="over-the-top-survey-form"
        backgroundColor={backgroundColor}
        alignment={alignment}
      />
    );
  }
  if (alchemerembedinpage === 'true') {
    return (
      <AlchemerSurveyOnPage
        backgroundColor={backgroundColor}
        embedurl={alchemerembedurl}
        alchemeriframeurl={alchemeriframeurl}
        alchemeriframeheight={alchemeriframeheight}
      />
    );
  }
if (alchemerembed === 'true') {
    return (
        <AlchemerSurvey
            id={id}
            backgroundColor={backgroundColor}
            embedurl={alchemerembedurl}
        />
    );
}
if (vendorForm === 'true') {
    const formProps = {
        className: classValue,
        text: typeof content === 'object' ? content.value || '' : content,
    };

    return (
            <VendorForm {...formProps} />
    );
}
if (sampleRequestFormOutput === 'true') {
    const formProps = {
        className: classValue,
        text: typeof content === 'object' ? content.value || '' : content,
        submitButton: submitButtonText,
        id: id,
    };

    return (
        <SampleRequestForm {...formProps} />
    );
}
if (surveyPage === 'header') {
    return (
        <ContentNoMarginComponent id={id} backgroundColor={backgroundColor} alignment={alignment}>
            <RichText className="rich-text-img-absolute" field={content} tag="div" editable={true.toString()}/>
        </ContentNoMarginComponent>
    );
}
if (surveyPage === 'true') {
    return (
        <BrownFullWidthTextComponent id={id} backgroundColor={backgroundColor} alignment={alignment}>
            <RichText className={richTextClassname} field={content} tag="div" editable={true.toString()}/>
        </BrownFullWidthTextComponent>
    );
}
    if (beanGame === 'true') {
        return (
            <BeanGameComponent
                alignment={alignment}
                backgroundColor={backgroundColor}
                poster = {videoPoster}
                field={content}
                tag="div"
                editable={true}
                id={id}
            />
        );
    }
  if (beanGame === 'new') {
    return (
      <UpdBeanGameComponent
        alignment={alignment}
        backgroundColor={backgroundColor}
        poster = {videoPoster}
        field={content}
        tag="div"
        editable={true}
        id={id}
      />
    );
  }
    if (videoTimeline === 'true') {
        return (
            <VideoTimelineComponent
                alignment={alignment}
                backgroundColor={backgroundColor}
                field={content}
                tag="div"
                editable={true}
                id={id}
                poster={videoPoster}
                title={title}
                timeLineVideo1={timeLineVideo1}
                timeLineVideo2={timeLineVideo2}
                timeLineVideo3={timeLineVideo3}
                timeLineVideo4={timeLineVideo4}
                timeLineVideo5={timeLineVideo5}
                timeLineVideo6={timeLineVideo6}
            />
        );
    }
    if (signupform === 'true') {
        return (
            <NewsletterFormComponent
                alignment={alignment}
                backgroundColor={backgroundColor}
                field={content}
                tag="div"
                editable={true}
            />
        );
    }
    if (socialmedia === 'true') {
        return (
            <SocialMediaComponent
                backgroundColor={backgroundColor}
                alignment={alignment}
                className={richTextClassname}
                field={content}
                tag="div"
                editable={true}
                id={id}
            />
        );
    }
    if(centeredVideoModule){
        return (
            <CenteredVideo
                backgroundColor={backgroundColor}
                alignment={alignment}
                className={richTextClassname}
                video={centeredVideo}
                videoId={vid}
                poster = {videoPoster}
                buttonText={buttonText}
                buttonUrl={buttonUrl}
                buttonColor={buttonColor}
                contestVideoPopup={contestVideoPopup}
                title={fields?.heading?.value || ''}
                field={content}
                tag="div"
                editable={true}
                posterText={posterText}
                id={id}
                bottomLink1={bottomLink1}
                bottomLink2={bottomLink2}
                textUnderVideo={textUnderVideo}
                disclosure={disclosure}
                backgroundImage={backgroundImage}
                modalHeading = {modalHeading}
                modalCopy = {modalCopy}
                modalLink = {modalLink}
                modalButton = {modalButton}
                includeModal = {includeModal}
                iframetitle = {iframetitle}
                vimeo = {vimeo}
            />
        );
    }
    if(centeredVideo){
        return (
            <CenteredVideoComponent
                backgroundColor={backgroundColor}
                alignment={alignment}
                className={richTextClassname}
                video={centeredVideo}
                videoId={vid}
                poster = {videoPoster}
                buttonText={buttonText}
                buttonUrl={buttonUrl}
                buttonColor={buttonColor}
                contestVideoPopup={contestVideoPopup}
                title={title}
                field={content}
                tag="div"
                editable={true}
                posterText={posterText}
                id={id}
                bottomLink1={bottomLink1}
                bottomLink2={bottomLink2}
                textUnderVideo={textUnderVideo}
                disclosure={disclosure}
                backgroundImage={backgroundImage}
                modalHeading = {modalHeading}
                modalCopy = {modalCopy}
                modalLink = {modalLink}
                modalButton = {modalButton}
                includeModal = {includeModal}
                iframetitle = {iframetitle}
                vimeo = {vimeo}
            />
        );
    }
    if (ytvideo) {
        return (
            <VideoRightComponent
                backgroundColor={backgroundColor}
                alignment={alignment}
                rtClass={richTextClassname}
                video={ytvideo}
                poster = {vidPoster}
                content={content}
                tag="div"
                editable={true}
                id={id}
            />
        );
    } else {
        if (site.name === 'bushs-beans-foodservices') {
            return (
                <ContentTextComponent
                    className={`fs-text-component ${noMargin ? 'noMargin' : ''}`}
                    id={id}
                    backgroundColor={backgroundColor}
                    headingcolor={headingcolor}
                    alignment={alignment}
                >
                    {heading?.value && (
                        <div className="content-container">
                            <h2 className="module-heading" dangerouslySetInnerHTML={{__html: heading?.value}}></h2>
                        </div>
                    )}
                    {content?.value && (
                        <RichText className={richTextClassname} field={content} tag="div" editable={true.toString()} />
                    )}
                    {tip?.value && (
                        <div className="content-container pro-tip">
                            <p dangerouslySetInnerHTML={{__html: tip?.value}}></p>
                        </div>
                    )}
                    {button?.value?.text && button?.value?.href && (
                        <div className={`content-container btn-wrapper ${alignment === 'center' ? 'justify-center' : ''}`}>
                            <Button
                                text={button.value.text}
                                href={button.value.href}
                                target={button.value.target}
                                {...button.value}
                                variant={buttonColor || "red"}
                                className="fade-in-up"
                            />
                        </div>
                    )}
                    {protip && (
                        <div className="content-container pro-tip">
                            <p>
                                <span className="bold">PRO TIP:</span>
                                <span dangerouslySetInnerHTML={{__html: protip}}></span>
                            </p>
                        </div>
                    )}
                    {buttonUrl && buttonText && !experienceEditor && (
                        <div className="content-container btn-wrapper">
                            <Button text={buttonText} href={buttonUrl} variant={buttonColor} />
                        </div>
                    )}
                </ContentTextComponent>
            );
        }else{
            return (
                <ContentTextComponent
                    id={id}
                    backgroundColor={backgroundColor}
                    headingcolor={headingcolor}
                    alignment={alignment}
                >
                    {heading?.value && (
                        <div className="content-container">
                            <h2 className="module-heading" dangerouslySetInnerHTML={{__html: heading?.value}}></h2>
                        </div>
                    )}
                    {content?.value && (
                        <RichText className={richTextClassname} field={content} tag="div" editable={true} />
                    )}
                    {tip?.value && (
                        <div className="content-container pro-tip">
                            <p dangerouslySetInnerHTML={{__html: tip?.value}}></p>
                        </div>
                    )}
                    {button?.value?.text && button?.value?.href && (
                        <div className={`content-container btn-wrapper ${alignment === 'center' ? 'justify-center' : ''}`}>
                            <Button
                                text={button.value.text}
                                href={button.value.href}
                                target={button.value.target}
                                type="default"
                                {...button.value}
                                variant={buttonColor || "red"}
                                className="fade-in-up"
                            />
                        </div>
                    )}
                    {protip && (
                        <div className="content-container pro-tip">
                            <p>
                                <span className="bold">PRO TIP:</span>
                                <span dangerouslySetInnerHTML={{__html: protip}}></span>
                            </p>
                        </div>
                    )}
                    {buttonUrl && buttonText && !experienceEditor && (
                        <div className="content-container btn-wrapper">
                            <Button text={buttonText} href={buttonUrl} variant={buttonColor} />
                        </div>
                    )}
                </ContentTextComponent>
            );
        }
    }
};

Text.propTypes = {
    title: PropTypes.string,
    fields: PropTypes.shape({
        content: PropTypes.object,
        heading: PropTypes.shape({
            value: PropTypes.string,
        }),
        button: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
            target: PropTypes.string,
        }),
    }),
    params: PropTypes.shape({
        alignment: PropTypes.oneOf(['left', 'center', 'right']),
        backgroundColor: PropTypes.oneOf(['tan', 'yellow']),
    }),
};

export default withSitecoreContext()(Text);